import { render, staticRenderFns } from "./wRadio.vue?vue&type=template&id=565ea998&scoped=true&"
import script from "./wRadio.vue?vue&type=script&lang=js&"
export * from "./wRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565ea998",
  null
  
)

export default component.exports